import React, {useCallback, useEffect, useRef, useState} from 'react';
import {CSSTransition} from 'react-transition-group';
import {classNames} from 'primereact/utils';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUser} from '@fortawesome/free-solid-svg-icons';
import {useTranslation} from 'react-i18next';
import settings from '../../config/settings';
import {hideWaitAnimation, showWaitAnimation} from '@dmt/global_npm';
import packageJson from './../../../package.json';
import preval from 'preval.macro';
import store from '../../redux/store';

const keycloakDisabled = process.env.REACT_APP_DISABLE_KEYCLOAK === 'true';

const UserMenus = (props: any) => {
    const {t} = useTranslation(['common']);
    const menuRef = useRef(null);

    const buildDatetime = preval`module.exports = new Date().toLocaleDateString();`;

    const isSlim = () => {
        return props.menuMode === 'slim';
    };

    const isStatic = () => {
        return props.menuMode === 'static';
    };

    const isSidebar = () => {
        return props.menuMode === 'sidebar';
    };

    const isMobile = () => {
        return window.innerWidth <= 991;
    };

    const isOverlay = () => {
        return props.menuMode === 'overlay';
    };

    useEffect(() => {
        return () => {
            document.getElementById('layout-css')?.removeEventListener('click', onLoad);
            document.getElementById('theme-css')?.removeEventListener('click', onLoad);
            document.getElementById('theme-css-lara')?.removeEventListener('click', onLoad);
        };
    }, []);

    useEffect(() => {
        if (props.colorScheme) {
            document.getElementById('layout-css')?.removeEventListener('click', onLoad);
            document.getElementById('theme-css')?.removeEventListener('click', onLoad);
            document.getElementById('theme-css-lara')?.removeEventListener('click', onLoad);

            onColorSchemeChange(props.colorScheme);
        }
    }, [props.colorScheme]);

    const onColorSchemeChange = (scheme: string) => {
        changeStyleSheetUrl('layout-css', 'layout-' + scheme + '.css', 1);
        changeStyleSheetUrl('theme-css', 'theme-' + scheme + '.css', 1);
        changeStyleSheetUrl('theme-css-lara', 'theme-' + scheme + '.css', 1);
        localStorage.setItem('Theme', scheme);
        window.dispatchEvent(new CustomEvent('themechange', {detail: scheme}));
    };

    const changeStyleSheetUrl = (id: any, value: any, from: any) => {
        const element = document.getElementById(id) as HTMLInputElement;
        if (element !== null) {
            const urlTokens = (element.getAttribute('href') as string).split('/');
            if (from === 1) {
                // which function invoked this function - change scheme
                urlTokens[urlTokens.length - 1] = value;
            } else if (from === 2) {
                // which function invoked this function - change color
                urlTokens[urlTokens.length - 2] = value;
            }

            const newURL = urlTokens.join('/');

            replaceLink(element, newURL);
        }
    };

    function onLoad(this: any) {
        const id = this.getAttribute('id');
        const _linkElement = document.getElementById(id.replace('-clone', ''));

        if (_linkElement) {
            _linkElement.parentElement?.removeChild(_linkElement);
        }

        this.setAttribute('id', id.replace('-clone', ''));
    }

    const replaceLink = (linkElement: any, href: string) => {
        const id = linkElement.getAttribute('id');
        const cloneLinkElement = linkElement.cloneNode(true);

        cloneLinkElement.setAttribute('href', href);
        cloneLinkElement.setAttribute('id', id + '-clone');

        linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

        cloneLinkElement.addEventListener('load', onLoad);
    };

    const onLogout = useCallback(() => {
        showWaitAnimation();
        const currentUrl = window.location.href;
        const state = store.getState();
        const keycloakIdToken = state.keycloakData.keycloak.keycloakIdToken;
        window.location.href = settings.logoutUrl
            + '?id_token_hint=' + keycloakIdToken
            + '&post_logout_redirect_uri=' + currentUrl;
        hideWaitAnimation();
    }, []);

    return (
        <>
            {(isStatic() || isSlim() || isSidebar()) && (
                <div
                    className={classNames('layout-inline-menu', {'layout-inline-menu-active': props.activeInlineProfile})}>
                    <button className="layout-inline-menu-action p-link" onClick={props.onChangeActiveInlineMenu}>
                        <FontAwesomeIcon className='user-icon' icon={faUser}/>
                        <i className="layout-inline-menu-icon pi pi-angle-up"></i>
                    </button>
                    <CSSTransition
                        nodeRef={menuRef}
                        classNames="p-toggleable-content"
                        timeout={{enter: 1000, exit: 450}}
                        in={props.activeInlineProfile}
                        unmountOnExit>
                        <ul ref={menuRef} className="layout-inline-menu-action-panel">
                            {!keycloakDisabled && (
                                <li className="layout-inline-menu-action-item">
                                    <button className="p-link" onClick={onLogout}>
                                        <i className="pi pi-power-off pi-fw"></i>
                                        <span>{t('logout')}</span>
                                    </button>
                                </li>
                            )}
                            <li className="layout-inline-menu-action-item">
                                <button className="p-link" onClick={() => {

                                    let cs = 'dark';

                                    switch (props.colorScheme) {
                                        case 'dark':
                                            cs = 'light';
                                            break;
                                    }

                                    props.setColorScheme(cs);
                                }}>
                                    <i className={'pi ' + (props.colorScheme == 'dark' ? 'pi-moon' : 'pi-sun') + ' pi-fw'}></i>
                                    <span>Theme</span>
                                </button>
                            </li>
                            <li className="layout-inline-menu-action-item">
                                <button className='p-link'
                                    onClick={props.onToggleMenu}>
                                    {/* {isOverlay() && <span className="pi pi-times"></span>}*/}
                                    {isSidebar() && !props.sidebarStatic &&
                                        <i className='pi pi-lock-open'></i>}
                                    {isSidebar() && props.sidebarStatic && <i className='pi pi-lock'></i>}
                                    <span>{t('sidebar')}</span>
                                </button>
                            </li>
                            <li className="layout-inline-menu-action-item">
                                <hr className={'-m-1 mt-1 mb-1'}></hr>
                            </li>
                            <li className="layout-inline-menu-action-item -mb-1" style={{cursor: 'default'}}>
                                <button className="p-link" style={{pointerEvents: 'none'}}>
                                    <i className="pi pi-question-circle pi-fw"></i>
                                    <span>{'v' + packageJson.version + ' (' + buildDatetime + ')'}</span>
                                </button>
                            </li>
                        </ul>
                    </CSSTransition>
                </div>
            )}
        </>
    );
};

export default UserMenus;
